export const Role = {
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer'
}
